<template>
  <div>
    <SubTitleView>{{ $t("profilePage.etablissement.siteWeb") }}</SubTitleView>
    <InputWithValidation
      v-model="localEtablissement.siteWeb"
      :label="$t(`profilePage.etablissement.adresseWeb`)"
      :placeholder="$t(`profilePage.etablissement.adresseWeb`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="siteWebEtablissement"
      autocomplete="etablissementSite"
      @manual-change="updateEtablissementSiteWeb"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import SubTitleView from "@/views/commons/SubTitleView.vue"
import { EtablissementDTO } from "@/model/bean/GeneratedDTOs"

export default defineComponent({
  name: "EtablissementSiteWebDetails",
  components: {
    InputWithValidation,
    SubTitleView,
  },
  props: {
    etablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    validationGroup: {
      type: String,
      default: "",
    },
  },
  emits: ["update-etablissement"],
  data() {
    return {
      localEtablissement: { ...this.etablissement } as EtablissementDTO,
    }
  },
  watch: {
    etablissement: {
      handler(newVal: EtablissementDTO) {
        this.localEtablissement = { ...newVal }
      },
      deep: true,
    },
  },
  methods: {
    updateEtablissementSiteWeb(): void {
      this.$emit("update-etablissement", this.localEtablissement)
    },
  },
})
</script>
